<template>
  <div class="card no-shadow">
    <div class="card-content p-x-0">
      <div class="content">

        <div class="columns margin-bottom-20">

          <div class="column is-paddingless margin-right-30 is-4">
            <search v-on:search="search($event)"
                    placeholder="Search by email or username"
                    :addMarginLeft=false
                    desktopCss="is-12-tablet is-11-desktop"
                    class="is-paddingless is-marginless"></search>
          </div>

          <div class="columns">
            <div class="column is-narrow">
              <span class="is-size-7 has-text-grey is-pulled-left">Status:&nbsp;</span>
            </div>

            <div class="column is-narrow is-paddingless">
              <multiple-selection-drop-down
                ref="status"
                class="is-paddingless is-marginless"
                data-track="Portal-Admin - Business Reviews Lists Status Dropdown change"
                btnMinWidth="button-width-200px"
                dropdownName="reviews_list"
                placeHolder="Select Status"
                :items.sync="user_status"
                :checkedItems="checkedItems"
                @checkbox-values="setReviewStatus"
              />
            </div>
          </div>
        </div>

        <p v-if="!fetching_data" v-resultsCount="[total_records, all_records]"></p>

        <div class="column is-paddingless">
          <table class="table is-size-7-touch is-marginless is-fullwidth reviewers-list">
            <thead>
            <tr>
              <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">First name</td>
              <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Last name</td>
              <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey" >Username</td>
              <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Email address</td>
              <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Role</td>
              <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey"><span class="fix-width-column-date">Registration&nbsp;Date</span></td>
              <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Status</td>
              <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey"></td>
            </tr>
            </thead>
            <tbody>
            <tr v-if="(is_loading && items.length === 0) || (!fetching_data && items.length === 0)">
              <td class="is-narrow pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey"
                  colspan="8">
                <p class="has-text-centered is-padded-20">No results found</p>
              </td>
            </tr>
            <tr class="margin-bottom-20" v-for="(item, index) in items" v-if="items.length > 0">
              <td class="is-narrow-mobile is-desktop" @click="gotoReviewerDetails(item)">{{item.first_name}}</td>
              <td class="is-narrow-mobile is-desktop" @click="gotoReviewerDetails(item)">{{item.last_name}}</td>
              <td class="is-narrow-mobile is-desktop" @click="gotoReviewerDetails(item)">{{item.username | wordwrap(30) }}</td>
              <td class="is-narrow-mobile is-desktop" @click="gotoReviewerDetails(item)">{{item.email}}</td>
              <td class="is-narrow-mobile is-desktop" @click="gotoReviewerDetails(item)">User</td>
              <td class="is-narrow-mobile is-desktop">{{item.created_at | prettyDate}}</td>
              <td class="is-narrow-mobile is-desktop first-letter-uppercase">{{item.status | statusText}}</td>
              <td
                class="is-narrow-mobile is-desktop is-uppercase activate-text"
                :class="[{'loader-padding': isActivating[index]}]"
                :key="updateIndex"
                @click="handleActivateUser(item.id, index)"
                v-if="isHavingPendingStatus && (item.status === 'NEW')"
              >
                <span v-if="!isActivating[index]">Activate</span>
                <img class="loader" src="/static/img/loaders/ajax-loader.gif" alt="loader" v-else>
              </td>
              <td class="is-narrow-mobile is-desktop is-uppercase" v-else></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <paginator :dataSet="dataSet" @changed="getReviewersListings"></paginator>
    </div>
  </div>


</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape, valid-jsdoc */
  import _ from 'lodash'
  import axios from 'axios'
  import Paginator from './../../components/Paginator.vue'
  import misc from '../../mixins/misc.js'
  import qs from 'qs'
  import moment from 'moment'
  import MultipleSelectionDropDown from './../../components/MultipleSelectionDropDown'
  import Search from './../../components/Search'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Users'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Users'
      })
    },
    components: {Paginator, MultipleSelectionDropDown, Search},
    mixins: [misc],
    data () {
      return {
        no_of_items: 0,
        is_loading: true,
        fetching_data: false,
        items: [],
        dataSet: {},
        page: undefined,
        total_records: 0,
        status_filter: '',
        keyword_search: undefined,
        keyword_string: undefined,
        statusPlaceholder: 'Select Status',
        selectAllItem: true,
        checkedItems: [],
        updateIndex: 0,
        users: [],
        isActivating: [],
        userStatus: [],
        user_status: [
          {
            name: 'Active',
            value: 1
          },
          {
            name: 'Blacklisted',
            value: 2
          },
          {
            name: 'Pending Activation',
            value: 3
          }
        ],
        all_records: -1
      }
    },
    computed: {
      /**
       * Check if user list having any pending status
       * @param {object} item Review slug
       * @returns {boolean}
       */
      isHavingPendingStatus () {
        return _.find(this.users, (user) => { return user.status === 'NEW' }) || false
      }
    },
    created () {
      if (this.$route.query.keyword) {
          this.keyword_search = qs.stringify({keyword: this.$route.query.keyword})
          this.keyword_string = this.$route.query.keyword
          this.getReviewersListings(1)
      }
      if (this.$route.query.status) {
          let statusData = this.$route.query.status
          let finalStatus = statusData.substring(statusData.indexOf('=') + 1)
          // this.status_filter = '&' + qs.stringify({status: finalStatus})
          this.user_status.forEach((item) => {
              if (item.value === finalStatus) {
                  this.statusPlaceholder = item.name
                  this.selectAllItem = false
                  this.checkedItems.push(item.value)
              }
          })
          this.getReviewersListings(1)
      } else {
          this.getReviewersListings(null)
      }
    },
    methods: {
      preventClick (event) {
        event.stopPropagation()
      },
      /**
       * Goes to reported reviews page for choosen busines
       * @param {object} item Review slug
       * @returns {void}
       */
      gotoReviewerDetails (item) {
        localStorage.reviewerListParam = JSON.stringify({
          keyword: this.keyword_string,
          status: this.status_filter,
          page: this.page
        })
        this.$router.push(`/reviewer-detail/${item.id}`)
      },
      /**
       * Make request to api to get reported reviews listings
       * @returns {number | null}
       * @param {number} page page number to paginate to
       */
      getReviewersListings (page) {
        this.page = page || 1
        this.fetching_data = true
        axios.get(this.url(page, this.keyword_search))
          .then((response) => {
            this.users = response.data.data
            this.refresh(response)
            this.is_loading = false
            this.fetching_data = false
            this.users.forEach((val, index) => {
              this.isActivating.push(false)
            })
          })
          .catch(() => {
            flash('You are not authorized to view this resource.', 'is-danger')
            this.is_loading = false
            this.fetching_data = false
          })
      },
      /**
       * Compute URI to make call to api with.
       * @param {string} page starting page to request
       * @param {string} keyword search keyword
       * @return {string}
       */
      url (page, keyword) {
        if (!page) {
          let query = location.search.match(/page=(\d+)/)
          page = query ? query[1] : 1
        }
        if (keyword !== undefined && this.keyword_string !== 0) {
          page += `&${keyword}`
        }
        if (this.status_filter !== '') {
          page += `${this.status_filter}`
        }
        return `/users/reviewers/?page=${page}`
      },
      /**
       * Search keyword/term to search for
       * @param {string} search search term/keyword
       * @returns {void}
       */
      search (search) {
        this.isActivating = []
        this.keyword_search = qs.stringify({keyword: search})
        this.keyword_string = search
        this.getReviewersListings(1)
      },
      /**
       * Sets Status method to filter by
       * @param {object} checkedValues
       * @returns {void}
       */
      setReviewStatus (checkedValues) {
        this.isActivating = []
        this.checkedItems = checkedValues
        this.userStatus = []
        let statusObj = {1: 'ACTIVE', 2: 'DELETED', 3: 'NEW'}
        checkedValues.forEach((key, val) => {
          this.userStatus.push(statusObj[key])
        })
        this.status_filter = ''
        if (this.userStatus) {
          this.userStatus.forEach((status, index) => {
            this.status_filter += `&status[${index}]=${status}`
          })
        }
        this.getReviewersListings(1)
      },
      /**
       * Activate new users
       * @param {NUmber} userId
       * @param {NUmber} userIndex
       * @returns {void}
       */
      handleActivateUser (userId, userIndex) {
        this.isActivating[userIndex] = true
        ++this.updateIndex
        axios.post(`admin/users/${userId}/activate`)
        .then(({data}) => {
          this.isActivating[userIndex] = false
          this.displaySuccessMsg(data.message, 'Portal - Admin | User Activated Successfully')
          this.getReviewersListings(1)
        })
        .catch(error => {
          this.isActivating[userIndex] = false
          flash(error.response, 'is-danger')
        })
      }
    },
    filters: {
      prettyDate (date) {
        if (date === null) return 'N/A'
        return moment(date).format('DD-MM-YYYY')
      },
      statusText (status) {
        return (status === 'NEW') ? 'Pending activation' : status.toLowerCase()
      },
      /**
       * Useful function to do a wordwrap in future
       * @param {string} str string
       * @param {int} width integer Width of String, 30 by default
       * @returns {*}
       */
      wordwrap (str, width) {
        width = width || 30
        let strArray = str.split('')
        if (strArray.length > width) {
          return strArray.splice(0, width).join('') + ' (...)'
        }
        return str
      }
    }
  }
</script>

<style scoped>
  .table td, .table th {
    border: none;
  }

  .table > tbody > tr {
    background-color: #f5f5f5 !important;
    margin-bottom: 10px;
  }

  .table > tbody > td {
    margin-bottom: 20px;
  }

  tr {
    cursor: pointer;
  }

  span.fix-width-column-date {
    width: 80px;
    display:block;
  }

  .is-on-grey-strap {
      background: transparent !important;
      border: 0;
  }

  .reviewers-list .first-letter-uppercase::first-letter {
    text-transform:uppercase;
  }

  .reviewers-list .first-letter-uppercase{
    text-transform:lowercase;
  }
  .activate-text {
    color: #30aae1;
    font-size: 11px;
    text-align: center;
    text-decoration: underline;
  }
  .loader-padding {
    padding: 15px 0 0 0 !important;
    text-align: -webkit-center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/users/ReviewersListing.vue